import { useTranslation } from 'react-i18next';

import {
  type ImageButtonProps as BaseImageButtonProps,
  type ImagePopoverProps as BaseImagePopoverProps,
  type ImageUploadCropProps as BaseImageUploadCropProps,
  RichTextEditor as BaseRichTextEditor,
} from '@valwin/facto/components';

type ImageButtonProps = Partial<BaseImageButtonProps>;
type ImagePopoverProps = Partial<BaseImagePopoverProps>;
type ImageUploadCropProps = Partial<BaseImageUploadCropProps>;

const ImageButton = ({ tooltip, ariaLabel }: ImageButtonProps = {}) => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.Image.Button
      tooltip={tooltip ?? t('richTextEditor image tooltip')}
      ariaLabel={ariaLabel ?? t('richTextEditor image ariaLabel')}
    />
  );
};

const ImagePopover = ({ title, sizeLabels }: ImagePopoverProps = {}) => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.Image.Popover
      title={title ?? t('richTextEditor image popoverTitle')}
      sizeLabels={{
        small: sizeLabels?.small ?? t('richTextEditor image sizeSmall'),
        medium: sizeLabels?.medium ?? t('richTextEditor image sizeMedium'),
        large: sizeLabels?.large ?? t('richTextEditor image sizeLarge'),
      }}
    />
  );
};

const ImageUploadCrop = ({
  dialogTitle,
  actionButtonLabels,
}: ImageUploadCropProps = {}) => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.Image.UploadCrop
      title={dialogTitle ?? t('richTextEditor image dialogTitle')}
      actionButtonLabels={{
        apply: actionButtonLabels?.apply ?? t('richTextEditor image apply'),
        reset: actionButtonLabels?.reset ?? t('richTextEditor image reset'),
      }}
    />
  );
};

function Image() {
  return (
    <BaseRichTextEditor.Image.Root>
      <ImageButton />
      <ImagePopover />
      <ImageUploadCrop />
    </BaseRichTextEditor.Image.Root>
  );
}

export { Image, ImageButton, ImagePopover, ImageUploadCrop };
